import React from 'react';
import { Counter } from './features/counter/Counter'
import './App.css';
import Header from './components/Header'
import Home from './components/Home'
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link
} from "react-router-dom";
import Details from './components/Details';
import Login from './components/Home/Login';

function App() {
  return (
    <div className="App">
      <Router>
        <Header/>
        <Routes>
          <Route path="/details/:id" element={<Details/>}/>
          <Route path="/login" element={<Login/>}/>
          <Route path="/" element={<Home/>}/>
          {/* <Route path="*" element={<NotFound/>}/> */}
        </Routes>
      </Router>
      
    </div>
  );
}

export default App;
